import React from "react";
import { contactName } from "../../helpers/ContactName";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, {
    apiCall,
    formattedPrice,
    getBranches,
    getCustomers
} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import Select from "react-select";
import withPermissions from "../../components/WithPermissions";

class SupplierPaymentAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            suppliers: [],
            banks: [],
            branches: [],
            loading: false,
            loadingBalance: false,
            selectedSupplier: null,
            balanceInfo: null,
            paymentData: {
                customer_id: '',
                amount: '',
                branch_id: '',
                collection_date: '',
                payment_type: '',
                description: '',
                bank_id: '',
            }
        }
    }

    async componentDidMount() {
        try {
            const customers = await getCustomers();
            const suppliers = customers.filter(c => c.is_supplier === 1);
            this.setState({
                suppliers: suppliers,
                branches: await getBranches()
            });
            this.getBanks();
        } catch (e) {
            console.error(e);
        }
    }

    getBanks = async () => {
        try {
            const response = await apiCall('business/settings/bank-account-list', 'get', null);
            this.setState({ banks: response });
        } catch (e) {
            console.error("Bankalar yüklenirken hata:", e);
        }
    };

    getSupplierBalance = async (supplierId) => {
        this.setState({ loadingBalance: true });
        try {
            const response = await apiCall(`business/receivable/supplier/get-balance/${supplierId}`, 'get', null);
            this.setState({ balanceInfo: response, loadingBalance: false });
        } catch (e) {
            console.error("Tedarikçi bakiyesi yüklenirken hata:", e);
            this.setState({ balanceInfo: null, loadingBalance: false });
        }
    };

    handlePaymentChange = (e) => {
        const { name, value } = e.target;
        this.setState(prevState => ({
            paymentData: {
                ...prevState.paymentData,
                [name]: value
            }
        }));
    }

    handleSupplierChange = (selectedSupplier) => {
        if (!selectedSupplier) {
            this.setState({
                paymentData: {
                    customer_id: '',
                    amount: '',
                    branch_id: '',
                    collection_date: '',
                    payment_type: '',
                    description: '',
                    bank_id: '',
                },
                selectedSupplier: null,
                balanceInfo: null
            });
            return;
        }

        const formattedSelectedOption = {
            value: selectedSupplier.value,
            label: selectedSupplier.label,
        };
        this.setState((prevState) => ({
            paymentData: {
                ...prevState.paymentData,
                customer_id: formattedSelectedOption.value
            },
            selectedSupplier: formattedSelectedOption
        }));

        // Tedarikçi bakiyesini çek
        this.getSupplierBalance(selectedSupplier.value);
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ loading: true });
        const { paymentData } = this.state;

        if (!paymentData.customer_id) {
            mainHelper.toastMessage('error', 'Lütfen bir tedarikçi seçiniz');
            this.setState({ loading: false });
            return;
        }

        const paymentFormData = new FormData();
        Object.keys(paymentData).forEach(key => {
            if (key !== 'customer_id') {
                paymentFormData.append(key, paymentData[key]);
            }
        });

        try {
            const response = await apiCall(
                `business/receivable/supplier/add-payment/${paymentData.customer_id}`,
                'post',
                paymentFormData
            );
            this.setState({
                loading: false,
                paymentData: {
                    customer_id: '',
                    amount: '',
                    branch_id: '',
                    collection_date: '',
                    payment_type: '',
                    description: '',
                    bank_id: '',
                },
                selectedSupplier: null
            });
            mainHelper.toastMessage(response.status, response.message);
        } catch (e) {
            this.setState({ loading: false });
        }
    }

    render() {
        const { loading, suppliers, branches, banks, selectedSupplier, balanceInfo, loadingBalance } = this.state;
        const { userPermissions } = this.props;
        const userHasNewReceivablePermission = userPermissions.includes('new receivable');

        const supplierFormattedOptions = suppliers && suppliers.map(option => ({
            value: option.id,
            label: contactName(option)
        }));

        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Tedarikçiye Ödeme Yap"
                            Breadcrumb={[
                                { name: "Finansal İşlemler", navigate: "" },
                                { name: "Tedarikçi İşlemleri", navigate: "" },
                                { name: "Ödeme Yap", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <div className="col-lg-12">
                                <div className="card">
                                    <form onSubmit={this.handleSubmit}>
                                        <div className="body">
                                            <h6>Tedarikçiye Ödeme Yapın</h6>
                                            <div className="row clearfix">
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="form-group">
                                                        <label htmlFor="customer" className="font-weight-bold text-cyan">
                                                            Tedarikçi
                                                        </label>
                                                        <Select
                                                            id="customer"
                                                            placeholder="Tedarikçi Seçiniz..."
                                                            options={supplierFormattedOptions}
                                                            value={selectedSupplier}
                                                            onChange={this.handleSupplierChange}
                                                            isClearable
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-lg-6 col-md-12">
                                                    <div className="form-group">
                                                        <label htmlFor="branch_id" className="font-weight-bold text-cyan">
                                                            Şube
                                                        </label>
                                                        <select
                                                            id='branch_id'
                                                            name='branch_id'
                                                            className="form-control"
                                                            value={this.state.paymentData.branch_id}
                                                            onChange={this.handlePaymentChange}>
                                                            <option value="">Şube Seçiniz</option>
                                                            {branches && (branches.map(branch => (
                                                                <option key={branch.id}
                                                                    value={branch.id}>{branch.name}</option>
                                                            )))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="form-group">
                                                        <label htmlFor="amount" className="font-weight-bold text-cyan">
                                                            Tutar
                                                        </label>
                                                        <input
                                                            name="amount"
                                                            id="amount"
                                                            type="number"
                                                            step="0.01"
                                                            className="form-control"
                                                            placeholder="Ödeme Tutarı Giriniz"
                                                            value={this.state.paymentData.amount}
                                                            onChange={this.handlePaymentChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="form-group">
                                                        <label htmlFor="payment_type" className="font-weight-bold text-cyan">
                                                            Ödeme Tipi
                                                        </label>
                                                        <select
                                                            name="payment_type"
                                                            id="payment_type"
                                                            className="form-control"
                                                            value={this.state.paymentData.payment_type}
                                                            onChange={this.handlePaymentChange}>
                                                            <option value="">Ödeme Tipi Seçiniz</option>
                                                            <option value="Nakit">Nakit</option>
                                                            <option value="Kredi Kartı">Kredi Kartı</option>
                                                            <option value="Havale/EFT">Havale/EFT</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="form-group">
                                                        <label htmlFor="collection_date" className="font-weight-bold text-cyan">
                                                            Ödeme Tarihi
                                                        </label>
                                                        <input
                                                            name="collection_date"
                                                            id="collection_date"
                                                            type="date"
                                                            className="form-control"
                                                            value={this.state.paymentData.collection_date}
                                                            onChange={this.handlePaymentChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="form-group">
                                                        <label htmlFor="bank_id" className="font-weight-bold text-cyan">
                                                            Banka
                                                        </label>
                                                        <select
                                                            name="bank_id"
                                                            id='bank_id'
                                                            className="form-control"
                                                            value={this.state.paymentData.bank_id}
                                                            onChange={this.handlePaymentChange}>
                                                            <option value="">Banka Seçiniz</option>
                                                            {banks && (banks.map(bank => (
                                                                <option key={bank.id} value={bank.id}>{bank.name}</option>
                                                            )))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 col-md-12">
                                                    <div className="form-group">
                                                        <label htmlFor="description" className="font-weight-bold text-cyan">
                                                            Açıklama
                                                        </label>
                                                        <textarea
                                                            name="description"
                                                            id="description"
                                                            placeholder="Açıklama giriniz (opsiyonel)"
                                                            className="form-control"
                                                            rows="3"
                                                            value={this.state.paymentData.description}
                                                            onChange={this.handlePaymentChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="body">
                                            <div className="row clearfix justify-content-center">
                                                <div className="col-lg-6 col-md-12">
                                                    {loading ? (
                                                        <button className="btn btn-outline-primary btn-block"
                                                            disabled={true}
                                                            style={{ textAlign: "-webkit-center" }}>
                                                            Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'}
                                                                height={'24px'}
                                                                color="#268bd2"></ReactLoading>
                                                        </button>
                                                    ) :
                                                        <button disabled={!userHasNewReceivablePermission}
                                                            className="btn btn-outline-primary btn-block"
                                                            type="submit">
                                                            Ödeme Yap
                                                        </button>}
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                        {/* Tedarikçi Cari Durumu - Ödeme Butonu Altında */}
                        {selectedSupplier && (
                            <div className="row clearfix">
                                <div className="col-lg-12">
                                    <div className="card">
                                        <div className="header" style={{
                                            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                                            borderBottom: '2px solid #dee2e6'
                                        }}>
                                            <h2 style={{ color: '#495057' }}>
                                                <i className="fa fa-info-circle mr-2"></i>
                                                Tedarikçi Cari Durumu
                                            </h2>
                                        </div>
                                        <div className="body">
                                            {loadingBalance ? (
                                                <div className="text-center py-5">
                                                    <ReactLoading type="spin" color="#17a2b8" height={50} width={50} className="mx-auto" />
                                                    <p className="text-muted mt-3 mb-0">Bakiye bilgisi yükleniyor...</p>
                                                </div>
                                            ) : balanceInfo ? (
                                                <div className="row clearfix">
                                                    {/* Toplam Borç */}
                                                    <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                        <div className="card" style={{
                                                            boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                                                            border: 'none',
                                                            borderTop: '4px solid #dc3545'
                                                        }}>
                                                            <div className="body text-center">
                                                                <div className="icon-in-bg bg-danger text-white shadow-sm" style={{
                                                                    width: '60px',
                                                                    height: '60px',
                                                                    borderRadius: '10px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    margin: '0 auto 15px'
                                                                }}>
                                                                    <i className="fa fa-credit-card" style={{ fontSize: '24px' }}></i>
                                                                </div>
                                                                <h6 className="text-muted mb-0">Toplam Borç</h6>
                                                                <h3 className="mb-0 font-weight-bold text-danger">
                                                                    {formattedPrice(balanceInfo.total_debt || 0)}
                                                                </h3>
                                                                <small className="text-muted">Toplam borç tutarı</small>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Toplam Ödenen */}
                                                    <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                        <div className="card" style={{
                                                            boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                                                            border: 'none',
                                                            borderTop: '4px solid #17a2b8'
                                                        }}>
                                                            <div className="body text-center">
                                                                <div className="icon-in-bg bg-info text-white shadow-sm" style={{
                                                                    width: '60px',
                                                                    height: '60px',
                                                                    borderRadius: '10px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    margin: '0 auto 15px'
                                                                }}>
                                                                    <i className="fa fa-money" style={{ fontSize: '24px' }}></i>
                                                                </div>
                                                                <h6 className="text-muted mb-0">Toplam Ödenen</h6>
                                                                <h3 className="mb-0 font-weight-bold text-info">
                                                                    {formattedPrice(balanceInfo.total_payed_debt || 0)}
                                                                </h3>
                                                                <small className="text-muted">Yapılan ödemeler</small>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Kalan Borç / Fazla Ödeme */}
                                                    <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                        <div className="card" style={{
                                                            boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                                                            border: 'none',
                                                            borderTop: balanceInfo.balance < 0 ? '4px solid #ffc107' : '4px solid #28a745'
                                                        }}>
                                                            <div className="body text-center">
                                                                <div className={`icon-in-bg ${balanceInfo.balance < 0 ? 'bg-warning' : 'bg-success'} text-white shadow-sm`} style={{
                                                                    width: '60px',
                                                                    height: '60px',
                                                                    borderRadius: '10px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    margin: '0 auto 15px'
                                                                }}>
                                                                    <i className={`fa ${balanceInfo.balance < 0 ? 'fa-exclamation-triangle' : 'fa-check-circle'}`} style={{ fontSize: '24px' }}></i>
                                                                </div>
                                                                <h6 className="text-muted mb-0">
                                                                    {balanceInfo.balance < 0 ? 'Kalan Borç' : 'Fazla Ödeme'}
                                                                </h6>
                                                                <h3 className={`mb-0 font-weight-bold ${balanceInfo.balance < 0 ? 'text-warning' : 'text-success'}`}>
                                                                    {formattedPrice(Math.abs(balanceInfo.balance || 0))}
                                                                </h3>
                                                                <small className="text-muted">
                                                                    {balanceInfo.balance < 0 ? 'Ödenecek tutar' : 'Kredi bakiyesi'}
                                                                </small>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Durum */}
                                                    <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                                        <div className="card" style={{
                                                            boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                                                            border: 'none',
                                                            borderTop: '4px solid #6c757d'
                                                        }}>
                                                            <div className="body text-center">
                                                                <div className="icon-in-bg bg-secondary text-white shadow-sm" style={{
                                                                    width: '60px',
                                                                    height: '60px',
                                                                    borderRadius: '10px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    margin: '0 auto 15px'
                                                                }}>
                                                                    <i className="fa fa-bar-chart" style={{ fontSize: '24px' }}></i>
                                                                </div>
                                                                <h6 className="text-muted mb-0">Cari Durum</h6>
                                                                <h4 className="mb-0 font-weight-bold" style={{
                                                                    color: balanceInfo.balance < 0 ? '#ffc107' : balanceInfo.balance > 0 ? '#28a745' : '#17a2b8'
                                                                }}>
                                                                    {balanceInfo.balance < 0
                                                                        ? 'Borçlu'
                                                                        : balanceInfo.balance > 0
                                                                            ? 'Kredi'
                                                                            : 'Dengede'}
                                                                </h4>
                                                                <small className={`badge ${balanceInfo.balance < 0
                                                                        ? 'badge-warning'
                                                                        : balanceInfo.balance > 0
                                                                            ? 'badge-success'
                                                                            : 'badge-info'
                                                                    }`}>
                                                                    {balanceInfo.balance < 0
                                                                        ? 'Ödeme Bekliyor'
                                                                        : balanceInfo.balance > 0
                                                                            ? 'Pozitif Bakiye'
                                                                            : 'Hesap Kapalı'}
                                                                </small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="alert alert-info mb-0">
                                                    <i className="fa fa-info-circle mr-2"></i>
                                                    Bu tedarikçi için henüz cari kayıt bulunmamaktadır.
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = () => ({});
export default withPermissions(withRouter(connect(mapStateToProps, {})(SupplierPaymentAdd)));
